import React from "react";
import ErhWorkspace from "./ErhWorkspace";
export default function AppAdminErhWorkspace() { return <ErhWorkspace role="admin" />; }
